import ReactPaginate from 'react-paginate';
import { oneLine } from 'common-tags';

import ChevronRight from '@/assets/icons/Derecha.svg';
import ChevronLeft from '@/assets/icons/Izquierda.svg';

import type { FunctionComponent } from 'react';
import type { TypePaginationProps } from './types';

export const Pagination: FunctionComponent<TypePaginationProps> = ({
  className = '',
  disabled = false,
  onPageChange,
  pageRangeDisplayed = 2,
  pageCount,
  renderOnZeroPageCount = () => null,
}: TypePaginationProps) => (
  <ReactPaginate
    previousLabel={
      <ChevronLeft
        width={24}
        height={24}
        className="fill-state-primary-default [&>ellipse]:!fill-transparent"
      />
    }
    nextLabel={
      <ChevronRight
        width={24}
        height={24}
        className="fill-state-primary-default [&>ellipse]:!fill-transparent"
      />
    }
    pageClassName="flex flex-row gap-3 items-center justify-center [&>a]:px-2 [&>a]:py-1 select-none text-center border-b border-transparent text-body--primary cursor-pointer"
    activeClassName="!border-state-primary-default !cursor-default pointer-events-none font-bold"
    disabledClassName="pointer-events-none opacity-40"
    onPageChange={onPageChange}
    pageRangeDisplayed={pageRangeDisplayed}
    pageCount={pageCount}
    renderOnZeroPageCount={renderOnZeroPageCount}
    marginPagesDisplayed={0}
    breakLabel={null}
    className={oneLine`
      flex flex-row items-center gap-3
      ${disabled ? 'pointer-events-none opacity-40' : ''}  
      ${className}
    `}
  />
);

Pagination.displayName = 'Pagination';
